import Vue from 'vue';
import { arrayify } from "../../lib/utils/array";
function mergeFn(parent, child) {
  const parentArray = arrayify(parent);
  if (!child) return parentArray;
  return parentArray.concat(child);
}
Vue.config.optionMergeStrategies.ucMethods = mergeFn;
Vue.config.optionMergeStrategies.ucEvents = mergeFn;
Vue.config.optionMergeStrategies.ucIsPatchedComponent = (a, b) => !!(a || b);
//# sourceMappingURL=vuePatch.js.map
